// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"585ee50d","453":"84c53fa7"}[chunkId] + ".chunk.js";
};